import React from "react";
import {
    Container,
    Stack,
    Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import SAILLogo from "../SAIL.svg";

const Home = () => {

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
            }}
        >
            {/* Centered Conversation */}
            <Container
                maxWidth="md"
                sx={{
                    flex: 1,
                    py: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                {/* Message Feed */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        overflowY: 'auto',
                        maxHeight: 'calc(100vh - 200px)',
                        textAlign: 'left',
                    }}
                >
                    <Stack direction="row" spacing={1} alignItems="center" alignSelf="center" sx={{mb:5}}>
                        <img
                            src={SAILLogo}
                            alt="SAIL Mentor"
                            style={{ maxHeight: '50px', height: '50px' }}
                        />
                        <Typography variant="h4" fontWeight="bold">
                            SAIL Mentor
                        </Typography>
                    </Stack>
                    <Typography>
                        SAIL Mentor is an AI tutor tool developed by Luke Edwards for his SENG402 full year cornerstone research project, at the University of Canterbury with the Computer Science and Software Engineering Department.
                    </Typography>
                    <Typography>
                        The project is is supervised by Dr. Trevor Nesbit and was proposed by Dr. Kathryn MacCallum, building upon MacCallum research in developing the Scaffolded AI Literacy (SAIL) framework and the AI Literacy Design Analyser, a web based tool co-developed by Dr. David Parsons and Dr. MacCallum.
                    </Typography>
                    <Typography whiteSpace={'pre-line'}>
                        {`The rapid adoption of artificial intelligence (AI) across disciplines, risks misuse by users unaware of its implications, necessitating AI literacy education. AI literacy is the competencies to ethically and effectively use AI in real-life contexts and not just being able to use generative AI. This is poorly understood outside the Computer Science field in higher education.
                        
                        While research exists, for tools allowing educators in designing full AI courses, none support embedding AI literacy into pre-existing course designs in higher education, epically outside of the Computer Science field.
                        
                        SAIL Mentor designed as a web based chat bot allows educators to save information about their course design and engage with Large Language Models (LLMs) in evaluating it through a SAIL framework lens while offering suggestions and clarity about AI literacy concepts.`}
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Home;
